import { render } from "./ResetResultView.vue?vue&type=template&id=79717642"
import script from "./ResetResultView.vue?vue&type=script&lang=js"
export * from "./ResetResultView.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2671924258/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__